if (!window.studioArtistCarouselBound) {
  window.studioArtistCarouselBound = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-studio-artist-step], [data-studio-artist-dot]');
    if (!button) return;

    const carousel = button.closest('[data-studio-artist-carousel]');
    if (!carousel) return;
    const slides = [...carousel.querySelectorAll('[data-studio-artist-slide]')];
    if (!slides.length) return;
    const current = Number(carousel.dataset.slideIndex || 0);
    const next = button.hasAttribute('data-studio-artist-dot')
      ? Number(button.dataset.studioArtistDot)
      : (current + Number(button.dataset.studioArtistStep) + slides.length) % slides.length;
    if (!Number.isInteger(next) || next < 0 || next >= slides.length) return;

    slides.forEach((slide, index) => {
      slide.hidden = index !== next;
    });
    carousel.dataset.slideIndex = String(next);
    carousel.querySelectorAll('[data-studio-artist-dot]').forEach((dot, index) => {
      const active = index === next;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-pressed', String(active));
    });
  });
}
